import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import ModalHandler from 'components/shared/modal/modal-handler'
import Modal from 'components/shared/modal'
import QuestionaireModalForm from 'forms/shared/questionaire-form'
import Instruction from 'components/shared/instructions/booking'
import ColStatus from '../col-status'
import { requestsInstruction, requestCancelReasons } from '../dataset'

const RequestList = ({ headers, list, fetchRequests, archiveRequest, cancelRequest }) => {
  useEffect(() => { fetchRequests() }, [])

  const DisplayDetails = item => {
    const { requestDate, notes } = item

    return (
      <ul className="my-3 text-sm">
        <li>{`Request Date: ${requestDate}`}</li>
        <li>{`Notes: ${notes}`}</li>
      </ul>
    )
  }

  const renderCanceModal = (id, toggle) => (
    <Modal
      className="bg-secondary-lightgray w-full rounded shadow-lg z-50"
      title="Why did you cancel the request?"
      titleClassName="mt-10 text-center text-xl">
      <QuestionaireModalForm
        onAccept={values => {
          cancelRequest({ id, ...values });
          toggle()
        }}
        onClose={toggle} reasons={requestCancelReasons} />
    </Modal>
  )

  const switchAction = (id, status, conversationId) => {
    switch (status) {
      case 'accepted':
        return (
          <>
            <li className="mx-1">
              <Link to={`/client/messages/${conversationId}/conversation`} target="_blank">Message Space</Link>
            </li>
            <ModalHandler title="Cancel" className="mx-1 cursor-pointer">
              {({ toggle }) => renderCanceModal(id, toggle)}
            </ModalHandler>
          </>
        )
      case 'pending':
        return (
          <ModalHandler title="Cancel" className="cursor-pointer">
            {({ toggle }) => renderCanceModal(id, toggle)}
          </ModalHandler>
        )
      default:
        return <li className="cursor-pointer" onClick={() => archiveRequest({ id })}>
          Archive
        </li>
    }
  }

  return (
    <div className="client-requests-list">
      <div className="mt-5">
        <Instruction instructions={requestsInstruction} />
        <div className="overflow-auto">
          <Table classes="w-full border-collapse">
            <THead classes="text-xs bg-lightgray font-semibold">
              {headers.map((header, key) => (
                <TCol classes="p-3" key={key} align={header.align || 'left'}>
                  {header.name}
                </TCol>
              ))}
            </THead>
            <TBody>
              {list.map(item => (
                <TRow classes="border-t text-sm hover:bg-gray-100"
                  key={item.id} PassedComponent={() => DisplayDetails(item.details)}>
                  <TCol classes="p-3">{item.createDate}</TCol>
                  <TCol classes="p-3">{item.leadType}</TCol>
                  <TCol classes="p-3">{item.requestDate}</TCol>
                  <TCol classes="p-3 text-primary-orange">
                    <Link to={item.spaceLink} target="_blank">{item.space}</Link>
                  </TCol>
                  <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                  <TCol classes="p-3" align="right">
                    <ul className="flex items-center font-semibold flex-row justify-end text-center text-primary-orange">
                      {switchAction(item.id, item.status, item.conversation_id)}
                    </ul>
                  </TCol>
                </TRow>
              ))}
            </TBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

RequestList.propTypes = {
  headers: PropTypes.array.isRequired,
  fetchRequests: PropTypes.func.isRequired,
  archiveRequest: PropTypes.func.isRequired,
  cancelRequest: PropTypes.func.isRequired,
  list: PropTypes.array,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.client.requests.headers,
  list: bookings.client.requests.list || [],
})

const mapDispatchToProps = {
  fetchRequests: bookingActions.fetchClientRequests,
  archiveRequest: bookingActions.archiveClientRequest,
  cancelRequest: bookingActions.cancelClientRequest,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequestList)
